const r = (t) => {
  const n = (o) => t((i) => ({ ...i, visitorInfo: { ...i.visitorInfo, ...o } }));
  return {
    visitorInfo: null,
    setVisitorInfo: (o) => n({ visitorInfo: o })
  };
};
export {
  r as createVisitorInfoSlice
};
